const REVIEW = '[REVIEW]';

export const SET_REVIEW = `${REVIEW} SET`;

export const setReview = data => ({
    type: SET_REVIEW,
    payload: {
        data
    }
});
